export class CustomGA4DataLayer {
  constructor() {
    this.data = {};
  }

  commonData() {
    this.data = {
      ...this.data,
      'user_id': window.user_id,
      'user_type': window.user_type,
      'hit_time_stamp': new Date().toLocaleString()
    }
  }

  trackEvent(eventName) {
    const dataToSend = this.data;
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ...dataToSend
    });
    this.data = {};

    console.log("Triggering event.......", eventName);
    // console.log(dataToSend);
    return dataToSend;
  }

  eventLoadingPage(page, page_name) {
    this.commonData();
    this.data = {
      ...this.data,
      'page_type': `${page} page`,
      'page_name': page_name
    }
    return this.trackEvent('custom_page_view');
  }

  eventSiteSearch(search_keyword, search_type, search_result_count) {
    this.commonData();
    this.data = {
      ...this.data,
      'search_keyword': search_keyword,
      'search_type': search_type,
      'search_result_count': search_result_count
    }
    return this.trackEvent('custom_site_search');
  }

  eventPopupChange(event_name, popup_name, popup_category, popup_id) {
    this.commonData();
    this.data = {
      ...this.data,
      'popup_name': popup_name,
      'popup_id': popup_id,
      'popup_category': popup_category
    }
    return this.trackEvent(event_name);
  }

  eventSpaMenuView() {
    this.commonData();
    return this.trackEvent('spa_menu_view');
  }

  eventCustomerAccount(event_name) {
    this.commonData();
    return this.trackEvent(event_name);
  }

  eventReferFriend(event_name) {
    this.commonData();
    return this.trackEvent('refer_friend');
  }

  eventNewsletterSignup(n_email) {
    this.commonData();
    this.data = {
      ...this.data,
      'newsletter_email': n_email
    }
    return this.trackEvent('newsletter_signup');
  }

  eventOpenIngredientsList(ingredient) {
    this.commonData();
    this.data = {
      ...this.data,
      'key_ingredient': ingredient
    }
    return this.trackEvent('open_full_ingredient_list');
  }

  eventCTATrigger(cta_text, cta_link) {
    this.commonData();
    this.data = {
      ...this.data,
      'cta_text': cta_text,
      'click_url': cta_link
    }
    return this.trackEvent('cta_click');
  }

  eventViewPromotion(event_name, param) {
    this.commonData();
    this.data = {
      ...this.data,
      'ecommerce': param
    }
    return this.trackEvent(event_name);
  }

  eventSelectItem(itemsData, ingredients, main_application) {
    this.commonData();

    var promoData = {
      'promotion_name': window.globalPromotionName,
      'promotion_id': window.globalPromotionId
    }

    this.data = {
      ...this.data,
      'key_ingredients': ingredients,
      'main_application': main_application,
      ecommerce: {
        ...promoData,
        items: itemsData
      }
    }
    return this.trackEvent('select_item');
  }

  eventReviewSubmit() {
    this.commonData();
    return this.trackEvent('review_submit');
  }

}